module.exports = __webpack_public_path__ + "static/media/bg.fd862270.png";